const globalHandles = {
    sidePouches: "p7-6x6pouchset",
    ihs: "p7-ihs",
    onePointSling: "p7-1ps",
    idPatches: "p7-idpset"
};

var platformProductData;

$(document).ready(function () {


// Trying out this accordion thing..

// select all the panels to be toggled and hide them initially
var allPanels = $('.step-body');

allPanels.slice(1).slideUp();

$('#step-PLATFORM').addClass('active');

// select all the clickable headers
var allHeaders = $('h2.step-header');

allHeaders.click(function() {
    $this = $(this);
    $target =  $this.next();
    $parent = $this.parent();
    if(!$parent.hasClass('active')){
       allPanels.slideUp();
       allPanels.parent().removeClass('active')
       $target.slideDown();
       $parent.addClass('active');
    } else if ($parent.hasClass('active')) {
        $target.slideUp();
        $parent.removeClass('active');
    }
    return false;
});



    // just resetting for now
    // future version -  try saving final selected options to localstorage or something, reload on page load
    $('#configurator-form')[0].reset();

    /* ****************************** 1. VEST ****************************** */
    async function fetchPlatformProductJSON() {
        const response = await fetch('/products/' + configConfig.platformProductHandle + '.js');
        const productData = await response.json();
        return productData;
    }

    fetchPlatformProductJSON().then(productData => {
        platformProductData = productData;
    });

    /* ****************************** SIDE POUCHES ****************************** */
    async function fetchSidePouchProductJSON() {
        const response = await fetch('/products/' + globalHandles.sidePouches + '.js');
        const productData = await response.json();
        return productData;
    }

    fetchSidePouchProductJSON().then(productData => {
        sidePouchProductData = productData;

        // console.log(sidePouchesProductData);
    });

    /* ****************************** CUMMERBUND ****************************** */

    if (configConfig.hasOwnProperty('cummerbundStdHandle')) {
        async function fetchCummerbundProductJSON() {
            const response = await fetch('/products/' + configConfig.cummerbundStdHandle + '.js');
            const productData = await response.json();
            return productData;
        }
        fetchCummerbundProductJSON().then(productData => {
            cummerbundStdProductData = productData;
        });
    }

    if (configConfig.hasOwnProperty('cummerbundApsHandle')) {
        async function fetchCummerbundApsProductJSON() {
            const response = await fetch('/products/' + configConfig.cummerbundApsHandle + '.js');
            const productData = await response.json();
            return productData;
        }
        fetchCummerbundApsProductJSON().then(productData => {
            cummerbundApsProductData = productData;
        });
    }

    /* ****************************** ONE POINT SLING ****************************** */
    async function fetchOnePointSlingProductJSON() {
        const response = await fetch('/products/' + configConfig.onepsProductHandle + '.js');
        const productData = await response.json();
        return productData;
    }

    fetchOnePointSlingProductJSON().then(productData => {
        onepsProductData = productData;
    });

    /* ****************************** IHS ****************************** */
    async function fetchIhsProductJSON() {
        const response = await fetch('/products/' + configConfig.ihsProductHandle + '.js');
        const productData = await response.json();
        return productData;
    }

    fetchIhsProductJSON().then(productData => {
        ihsProductData = productData;
        // console.log(ihsProductData);
    });

    /* loop through product data and map variant ID's to selected options somehow */



    /****** CLEAR CART REQUEST
     * For testing purposes at least lets clear the "cart" on page load */
    async function clearCart() {
        const response = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const cartResponse = await response.json();
        return cartResponse;
    }

    // clearCart()
    //     .then(cartResponse => {

    //     })
    //     .catch((error) => {
    //         console.error('Error:', error);
    //     });

    /******END CLEAR CART REQUEST */

    $('#configurator-form').on('submit', function(e){
        e.preventDefault();
        return false;
    });

    addImageListeners();
});

// color opts for ref
// blk = black (changed from bb in some places)
// odb = olive drab/black (changed from ob in some places)
// oo = olive drab / olive drab
// mc = multicolor

function fadeOutLayer(layerName) {
    $(layerName).fadeOut(100, function () {
        $(layerName).attr('src', '');
        $(layerName).show();
    });
}

function getImgURL(itemLetter, itemType) {
    let imgURL = 
        configConfig.imageBaseUrl +
        configConfig.platformImgPrefixCode + 
        itemLetter +
        '-p7-' +
        configConfig.platformImgRoot +
        '-' +
        selectedOptions.platform.color +
        '-' +
        selectedOptions.platform.closureType +
        '-stm-' +
        itemType +
        '.png';

        // console.log(imgURL)

    return imgURL;
}

function loadLayerImg(layerID, itemLetter, itemType) {
    let imgURL = 
        configConfig.imageBaseUrl +
        configConfig.platformImgPrefixCode + 
        itemLetter +
        '-p7-' +
        configConfig.platformImgRoot +
        '-' +
        selectedOptions.platform.color +
        '-' +
        selectedOptions.platform.closureType +
        '-stm-' +
        itemType +
        '.png';

        $(layerID)
            .attr('src', imgURL)
            .fadeIn(2000, function () {
                // $(layerID);
                // $(layerID).show();
            });
        // $(layerID).attr('src', imgURL)
}

// the main function for listening to inputs to change img.
// may break out into different ones for different sections, etc.
function addImageListeners() {
    $('input[type="checkbox"], input[type="radio"], input[type="number"]').on('change', function (e) {

        var $theInput = $(this);
        var inputVal = ($theInput.val()).toLowerCase();
        var inputName = $theInput.attr('name');

        switch ($theInput.attr('type')) {
            case 'checkbox':
                var isChecked = $theInput.prop('checked');
                var checkboxID = $theInput.attr('id');
                // if it's a toggle that shows the next bit. Sprinkle a transition/animation perhaps, use a class instead?
                if ($theInput.hasClass('show-next')) {
                    if (isChecked) {
                        $('.component-options[data-component="' + $theInput.data('component-id') + '"]').show();
                    } else {
                        $('.component-options[data-component="' + $theInput.data('component-id') + '"]').hide();
                    }
                }
                // many checkboxes load images and do other things too, trying to think out if any of that functionality could be merged in with stuff below (one section to deal with each step)
                switch (checkboxID) {
                    // there are 16 checkboxes, better way to go about this?
                    case 'plate-pouch-toggle':
                        // for the 6x6 Side Plate Pouch Set
                        var imgLayer = '#layer-rifle-plate-pouch';
                        selectedOptions.pouch.selected = isChecked ? true : false;
                        if (isChecked) {
                            loadLayerImg(
                                imgLayer,
                                selectedOptions.pouch.itemLetter,
                                selectedOptions.pouch.itemSuffix
                            )
                        } else {
                            fadeOutLayer(imgLayer);
                        }
                        // add to selectedOptions with selected plate model
                        break;
                    case 'yoke-toggle':
                        selectedOptions.yoke.selected = isChecked ? true : false;
                        $('input[name="yoke[collar]"]:checked').trigger('change');
                        break;
                    case 'upper-arms-toggle':
                        var imgLayer = '#layer-upper-arms';
                        selectedOptions.upperArms.selected = isChecked ? true : false;
                        if (isChecked) {
                            loadLayerImg(
                                imgLayer,
                                selectedOptions.upperArms.itemLetter,
                                selectedOptions.upperArms.itemSuffix
                            );
                            $('#component-arm-patch').show()

                            selectedOptions.upperArms.selected = true;
                        } else {

                            $('#component-arm-patch').hide()
                            fadeOutLayer(imgLayer);
                            selectedOptions.upperArms.selected = false;
                            selectedOptions.patches.arm.selected = false;
                            $('#arm-patch-toggle').prop('checked', false);
                        }

                        // add product to selected options
                        break;
                    case 'spinal-toggle':
                        selectedOptions.spinal.selected = isChecked ? true : false;
                        break;
                    case 'groin-toggle':
                        selectedOptions.groin.selected = isChecked ? true : false;
                        $('input[name="groin[type]"]:checked').trigger('change');
                        if (selectedOptions.abs.selected && (!selectedOptions.groin.selected)) {
                            $('input#abs-toggle').trigger('change');
                        }
                        break;
                    case 'abs-toggle':
                        var imgLayer = "#layer-abs";
                        selectedOptions.abs.selected = isChecked ? true : false;
                        $('input[name="groin[type]"]:checked').trigger('change');

                        if (isChecked && (!selectedOptions.groin.selected)) {
                            loadLayerImg(
                                imgLayer,
                                selectedOptions.abs.itemLetter,
                                selectedOptions.abs.itemSuffix
                            )
                        } else {
                            fadeOutLayer(imgLayer);
                        }
                        break;

                    case 'arm-patch-toggle':
                        selectedOptions.patches.arm.selected = isChecked ? true : false;
                        $('#step-patches input[type="radio"]:checked').trigger('change');
                        break;
                    case 'front-patch-toggle':
                        selectedOptions.patches.front.selected = isChecked ? true : false;
                        break;
                    case 'back-patch-toggle':
                        selectedOptions.patches.back.selected = isChecked ? true : false;
                        break;
                    case 'ihs-toggle':
                        // helmet
                        var imgLayer = '#layer-helmet';
                        selectedOptions.helmet.selected = isChecked ? true : false;
                        if (isChecked) {
                            $(imgLayer).attr('src',
                                configConfig.imageBaseUrl+
                                '07a-p7-config-ihs-'+
selectedOptions.platform.color+
                                '-hc.png');
                        } else {
                            fadeOutLayer(imgLayer);
                        }
                        $('div[data-component="ihs"] input:checked').trigger('change')
                        break;
                    // belts
                    case 'b1x-belt-toggle':
                        var imgLayer = '#layer-belt';
                        selectedOptions.belt.selected = isChecked ? true : false;
                        if (isChecked) {
                            loadLayerImg(
                                imgLayer,
                                selectedOptions.belt.itemLetter,
                                selectedOptions.belt.itemSuffix
                            )
                        } else {
                            fadeOutLayer(imgLayer);
                        }
                        break;
                    // case 'p7pouches-toggle':
                    //     selectedOptions.extraacc.p7pouchset.selected = isChecked ? true : false;
                    

                    //     if (isChecked) {
                    //         if($('#pouch-set').length) {
                    //             $('#pouch-set').show();
                    //         } else {
                    //             $('.other-products').append('<img src="https://aard-web-assets.s3.us-west-2.amazonaws.com/aard-site-product-images/p7-configurator/other-products/p7_pouch_utility.3x6v_f.jpg" alt="" id="pouch-set" >');
                    //         }
                    //     } else {
                    //         $('#pouch-set').hide().remove();
                    //     }
                    //     break;
                    case 'p7pouches3-toggle':
                        selectedOptions.extraacc.p7pouchset3.selected = isChecked ? true : false;
                    

                        if (isChecked) {
                            if($('#pouch-set').length) {
                                $('#pouch-set').show();
                            } else {
                                $('.other-products').append('<img src="https://aard-web-assets.s3.us-west-2.amazonaws.com/aard-site-product-images/p7-configurator/other-products/p7_pouch_utility.3x6v_f.jpg" alt="" id="pouch-set" >');
                            }
                        } else {
                            $('#pouch-set').hide().remove();
                        }
                        break;
                    case 'p7pouches4-toggle':
                        selectedOptions.extraacc.p7pouchset4.selected = isChecked ? true : false;
                    

                        if (isChecked) {
                            if($('#pouch-set').length) {
                                $('#pouch-set').show();
                            } else {
                                $('.other-products').append('<img src="https://aard-web-assets.s3.us-west-2.amazonaws.com/aard-site-product-images/p7-configurator/other-products/p7_pouch_utility.3x6v_f.jpg" alt="" id="pouch-set" >');
                            }
                        } else {
                            $('#pouch-set').hide().remove();
                        }
                        break;
                    case 'p7pouches5-toggle':
                        selectedOptions.extraacc.p7pouchset5.selected = isChecked ? true : false;
                    

                        if (isChecked) {
                            if($('#pouch-set').length) {
                                $('#pouch-set').show();
                            } else {
                                $('.other-products').append('<img src="https://aard-web-assets.s3.us-west-2.amazonaws.com/aard-site-product-images/p7-configurator/other-products/p7_pouch_utility.3x6v_f.jpg" alt="" id="pouch-set" >');
                            }
                        } else {
                            $('#pouch-set').hide().remove();
                        }
                        break;
                    case 'one-point-sling-toggle':
                        selectedOptions.extraacc.oneps.selected = isChecked ? true : false;
                        if (isChecked) {
                            if($('#1ps-img').length) {
                                $('#1ps-img').show();
                            } else {
                                $('.other-products').append('<img src="https://aard-web-assets.s3.us-west-2.amazonaws.com/aard-site-product-images/p7-configurator/other-products/p7-1ps-wa-hk-blk-A.jpg" alt="" id="1ps-img" >');
                            }
                        } else {
                            $('#1ps-img').hide().remove()
                        }
                        $('div[data-component="one-point-sling"] input[type="radio"]:checked').trigger('change');
                        break;
                    case 'ihs-toggle':
                        selectedOptions.helmet.selected = isChecked ? true : false;
                        $('div[data-component="ihs"] input:checked').trigger('change');
                        break;
                    case 'asr-bag-toggle':
                        selectedOptions.asr_bag.selected = isChecked ? true : false;
                        break;
                    case 'asr-mag-pouch-toggle':
                        selectedOptions.asr_mag_pouch.selected = isChecked ? true : false;
                }
                break;

            case 'radio':
                switch (inputName) {
                    // 1. Platform
                    case 'platform[color]':
                        var layerName = '#layer-platform';
                        selectedOptions.platform.color = inputVal;
                        loadLayerImg(
                            layerName,
                            selectedOptions.platform.itemLetter,
                            'frnt'
                        )
                        $('[data-inherits="platform:color"] input:checked').trigger('change');
                        break;
                    case 'platform[style]':
                        var layerName = '#layer-platform-load';
                        if (inputVal != 'stm') { // <-- stm = default, no image to display on layer
                            //** should get more of these image file name things into a config object

                            loadLayerImg(
                                layerName,
                                ((inputVal == 'flx') ? 'd' : 'e'),
                                inputVal
                            )
                            var imgLink =
                                configConfig.imageBaseUrl +
                                ((inputVal == 'flx') ? '03d' : '03e') +
                                '-p7-'+configConfig.platformImgRoot+'-' +
                                (selectedOptions.platform.color).toLowerCase() +
                                '-t-stm-' + inputVal + '.png';


                            $(layerName).attr('src', imgLink);
                        } else {
                            fadeOutLayer(layerName);
                        }
                        selectedOptions.platform.load = $theInput.data('name');
                        break;
                    case 'platform[closure]':
                        selectedOptions.platform.closureType = inputVal;
                        // console.log(inputVal);
                        $('input[name="platform[color]"]:checked').trigger('change');
                        $('[data-inherits="platform:color"] input:checked').trigger('change');
                        break;
                    case 'platform[lining]':
                        selectedOptions.platform.lining = $theInput.data('name');
                        break;
                    case 'platform[ballistics]':
                        selectedOptions.platform.ballistics.type = inputVal;
                        break;
                    // 2. Rifle Plates - Primary
                    case 'plate[id]':
                        selectedOptions.primaryPlate.id = inputVal;
                        $('[data-inherits="primaryPlate:id"] input:checked').trigger('change');
                        break;
                    // 2.5 Rifle Plates - Pouchs
                    case 'rifle-plate[model]':
                        selectedOptions.pouch.type = inputVal;
                        $('[data-inherits="pouch:type"] input:checked').trigger('change');
                        break;
                    // 3 Cummerbund - no image changes
                    case 'cummerbund[type]':
                        selectedOptions.cummerbund.type = $theInput.data('name');
                        if (selectedOptions.cummerbund.type == 'ballistic-with-pouch') {
                            $('#component-ballistics.upr-ballistics').show();
                        } else {
                            $('#component-ballistics.upr-ballistics').hide();
                        }
                        break;
                    case 'cummerbund[ballistics]':
                        // console.log(inputVal);
                        selectedOptions.ballistics.type = inputVal;
                        break;
                    // 4. Accessory Ballistics
                    // 4.1 Yoke

                    case 'yoke[collar]':
                        var imgLayerYoke = '#layer-yoke';
                        var imgLayerYokeCollar = '#layer-yoke-collar';
                        var imgLayerYokeThroat = '#layer-yoke-throat';
                        selectedOptions.yoke.type = inputVal;
                        // console.log(inputVal)

                        if (selectedOptions.yoke.selected) {
                            // 'tp' = throat piece
                            if (selectedOptions.yoke.type == 'yknc') {
                                loadLayerImg(
                                    imgLayerYoke,
                                    selectedOptions.yoke.options.yknc.itemLetter,
                                    selectedOptions.yoke.options.yknc.itemSuffix
                                )
                                fadeOutLayer(imgLayerYokeCollar)
                                fadeOutLayer(imgLayerYokeThroat)
                                // add just yoke
                                selectedOptions.yoke.options.yknc.selected = true;
                                selectedOptions.yoke.options.ykc.selected = false;
                                selectedOptions.yoke.options.tp.selected = false;
                            }

                            if (selectedOptions.yoke.type == 'ykc') {
                                loadLayerImg(
                                    imgLayerYoke,
                                    selectedOptions.yoke.options.yknc.itemLetter,
                                    selectedOptions.yoke.options.yknc.itemSuffix
                                )
                                loadLayerImg(
                                    imgLayerYokeCollar,
                                    selectedOptions.yoke.options.ykc.itemLetter,
                                    selectedOptions.yoke.options.ykc.itemSuffix
                                )
                                fadeOutLayer(imgLayerYokeThroat);
                                selectedOptions.yoke.options.yknc.selected = false;
                                selectedOptions.yoke.options.ykc.selected = true;
                                selectedOptions.yoke.options.tp.selected = false;
                            }

                            if (selectedOptions.yoke.type == 'tp') {
                                loadLayerImg(
                                    imgLayerYoke,
                                    selectedOptions.yoke.options.yknc.itemLetter,
                                    selectedOptions.yoke.options.yknc.itemSuffix
                                )
                                loadLayerImg(
                                    imgLayerYokeCollar,
                                    selectedOptions.yoke.options.ykc.itemLetter,
                                    selectedOptions.yoke.options.ykc.itemSuffix
                                )
                                loadLayerImg(
                                    imgLayerYokeThroat,
                                    selectedOptions.yoke.options.tp.itemLetter,
                                    selectedOptions.yoke.options.tp.itemSuffix
                                )
                                //check this later lol
                                selectedOptions.yoke.options.yknc.selected = false;
                                selectedOptions.yoke.options.ykc.selected = true;
                                selectedOptions.yoke.options.tp.selected = true;
                            }
                        } else {
                            fadeOutLayer(imgLayerYoke);
                            fadeOutLayer(imgLayerYokeCollar);
                            fadeOutLayer(imgLayerYokeThroat);
                            selectedOptions.yoke.options.yknc.selected = false;
                            selectedOptions.yoke.options.ykc.selected = false;
                            selectedOptions.yoke.options.tp.selected = false;
                        }
                        selectedOptions.yoke.type = inputVal;

                        $('[data-inherits="yoke:type"] input:checked').trigger('change');

                        break;
                        case 'groin[type]':
                            var imgLayer = '#layer-groin';
                            selectedOptions.groin.type = inputVal;
    
                            if (selectedOptions.groin.selected) {
                                loadLayerImg(
                                    imgLayer,
                                    (selectedOptions.groin.options[selectedOptions.groin.type].abs[selectedOptions.abs.selected ? 'yes' : 'no'].itemLetter),
                                    (selectedOptions.abs.selected ? 'abs' : '')+selectedOptions.groin.type
                                )
                                                            fadeOutLayer('#layer-abs');

                            } else {

                                fadeOutLayer(imgLayer);
                            }
    
                            break;
    

                    // 6. BELT
                    case 'b1x[type]':
                        if (selectedOptions.belt.selected) {
                            selectedOptions.belt.type = inputVal;
                            // console.log(inputVal);
                        }
                        break;

                    // 7. EXTRA ACCESSORIES

                    case 'one-point-sling[slingtype]':
                        selectedOptions.extraacc.oneps.slingType = inputVal;
                        break;
                    case 'one-point-sling[weaponattachment]':
                        selectedOptions.extraacc.oneps.attachType = inputVal;
                        break;
                    case 'ihs[cut]':
                        selectedOptions.helmet.cut = inputVal;
                        break;
                    case 'ihs[weight]':
                        selectedOptions.helmet.weight = inputVal;
                        break;
                }
                // code

                break;

            case 'number':
                switch (inputName) {
                    case 'plate[__qty]':
                        selectedOptions.primaryPlate.quantity = inputVal;
                        if (inputVal != 0) {
                            // if($('#plates').length) {
                                $('#plates').show();
                            // } else {
                                // $('.other-products').append('<img src="https://aard-web-assets.s3.us-west-2.amazonaws.com/aard-site-product-images/p7-configurator/other-products/p7-rp-3p-sa-lw-A.jpg" alt="" id="plates" >');
                            // }
                        } else {
                            $('#plates').hide()
                        }
                        break;

                    // case 'asr-bag[__qty]':
                    //     selectedOptions.asr_bag.quantity = inputVal;
                    //     break;
                }
                break;
            default:
            // code
        }
    })

    // initially just add default black vest on load
    loadLayerImg('#layer-platform', selectedOptions.platform.itemLetter, 'frnt')
    // sometimes other default stuff

    if (selectedOptions.yoke.selected) {
        $('[data-component="yoke"] input:checked').trigger('change');

    }
    if (selectedOptions.primaryPlate.quantity != 0) {
        $('input[name="plate[__qty]"]').trigger('change');
    }
}

let formData = {
    'items': []
};

function addToItems(productID, productQuantity = 1) {
    formData.items.push({
        id: productID,
        quantity: Number(productQuantity)
    })
}

function addToCartPlz(e) {

    formData = {
        'items': []
    };

    /* ****************************** 1. VEST ****************************** */

    // is this correct for all products with colors? Isn't on helmet, but that is separate in a way
    var colorFullNames = {
        bb: 'BLACK/BLACK',
        oo: 'OLIVE DRAB/OLIVE DRAB',
        ob: 'OLIVE DRAB/BLACK',
        mc: 'MULTICAM'
    }

    // turn selectedOptions into a string that will match variant title
    // due to issues from various changes, just hardcoding how to format title for diff platform types
    var platformTitle = colorFullNames[selectedOptions.platform.color];

    switch (configConfig.platformImgRoot) {
        case 'spr-rt':
        case 'spr-pw':
            platformTitle = colorFullNames[selectedOptions.platform.color] + ' / ' +
                selectedOptions.platform.load + ' / ' +
                selectedOptions.platform.lining;
            break;
        case 'sev2-aw':
        case 'sev2-rt':
        case 'trv-pw':
        case 'trv-rt':
            platformTitle = 
            colorFullNames[selectedOptions.platform.color] + ' / ' +
            (selectedOptions.platform.closureType == 't' ? 'Tubes' : 'Velcro');
            break;
    }

    // loop through platform variants to get ID and add to formData for submission
    for (let index = 0; index < platformProductData.variants.length; index++) {
        if (platformProductData.variants[index].title == platformTitle) {
            addToItems(platformProductData.variants[index].id);
        }
    }

    /* ****************************** 2. RIFLE PLATES ****************************** */

    if (selectedOptions.primaryPlate.quantity > 0) {
        addToItems(selectedOptions.primaryPlate.options[selectedOptions.primaryPlate.id], selectedOptions.primaryPlate.quantity);
    }

    // side plate pouch set

    if (selectedOptions.pouch.selected != false) {

        // some don't have the slash in the name
        var colorShortNames = {
            bb: 'Black',
            oo: 'Olive Drab',
            ob: 'Olive Drab',
            mc: 'Multicam'
        }

        // turn selectedOptions into a string that will match variant title
        var sidePouchTitle =
            selectedOptions.pouch.fullTitle[selectedOptions.pouch.type] + ' / ' +
            colorShortNames[selectedOptions.platform.color];

        // loop through platform variants to get ID and add to formData for submission
        for (let index = 0; index < sidePouchProductData.variants.length; index++) {
            // const element = array[index];
            if ((sidePouchProductData.variants[index].title).toLowerCase() == (sidePouchTitle).toLowerCase()) {
                addToItems(sidePouchProductData.variants[index].id)
            }
        }
    }

    /* ****************************** 3. CUMMERBUND ****************************** */

if (selectedOptions.cummerbund.type != false) {
    if (selectedOptions.cummerbund.type == 'Standard 3 Piece Cummerbund') {

        var closureType = {
            t: 'Tubes',
            v: 'Velcro'
        }

        // function to remove ' Lining' from end of string
        function removeLining(str) {
            return str.replace(/ Lining$/, '');
        }

        // turn selectedOptions into a string that will match variant title
        var cummerbundStdTitle =
            closureType[selectedOptions.platform.closureType] + ' / ' +
            removeLining(selectedOptions.platform.lining) + ' / ' +
            colorFullNames[selectedOptions.platform.color];

        // console.log(cummerbundStdTitle);
        // return false;

        // loop through platform variants to get ID and add to formData for submission
        for (let index = 0; index < cummerbundStdProductData.variants.length; index++) {
            if ((cummerbundStdProductData.variants[index].title).toLowerCase() == (cummerbundStdTitle).toLowerCase()) {
                addToItems(cummerbundStdProductData.variants[index].id)
            }
        }
    }

    if (selectedOptions.cummerbund.type == '3PC w/ Adaptive Pouch System') {

        var closureType = {
            t: 'Tubes',
            v: 'Velcro'
        }

        // function to remove ' Lining' from end of string
        function removeLining(str) {
            return str.replace(/ Lining$/, '');
        }

        // turn selectedOptions into a string that will match variant title
        var cummerbundApsTitle =
            closureType[selectedOptions.platform.closureType] + ' / ' +
            removeLining(selectedOptions.platform.lining) + ' / ' +
            colorFullNames[selectedOptions.platform.color];

        // loop through platform variants to get ID and add to formData for submission
        for (let index = 0; index < cummerbundApsProductData.variants.length; index++) {
            // const element = array[index];
            if ((cummerbundApsProductData.variants[index].title).toLowerCase() == (cummerbundApsTitle).toLowerCase()) {
                addToItems(cummerbundApsProductData.variants[index].id)
            }
        }
    }

    // slightly different for the UPR
    if (selectedOptions.cummerbund.type == 'non-ballistic' || selectedOptions.cummerbund.type == 'ballistic-with-pouch') {
        addToItems(selectedOptions.cummerbund.options[selectedOptions.cummerbund.type].productIDs[selectedOptions.platform.color]);
    }
} 

  if (selectedOptions.ballistics.type != false) {

    if (selectedOptions.cummerbund.type != 'non-ballistic') {
        addToItems(selectedOptions.ballistics.options[selectedOptions.ballistics.type]);
    }
  }

    /* ****************************** 4. ACCESSORY BALLISTICS ****************************** */

    // For these there are only 4 product ID's per item, so going ahead and placing those in the selectedOptions object

    // yoke
    if (selectedOptions.yoke.options.yknc.selected) {
        addToItems(selectedOptions.yoke.options.yknc.productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.yoke.options.yknc.balProductIDs[selectedOptions.ballistics.type]);
    }
    if (selectedOptions.yoke.options.ykc.selected) {
        addToItems(selectedOptions.yoke.options.ykc.productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.yoke.options.ykc.balProductIDs[selectedOptions.ballistics.type]);
    }
    if (selectedOptions.yoke.options.tp.selected) {
        addToItems(selectedOptions.yoke.options.tp.productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.yoke.options.tp.balProductIDs[selectedOptions.ballistics.type]);
    }
    // abdominal
    if (selectedOptions.abs.selected) {
        addToItems(selectedOptions.abs.productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.abs.balProductIDs[selectedOptions.ballistics.type]);
    }
    if (selectedOptions.upperArms.selected) {
        addToItems(selectedOptions.upperArms.productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.upperArms.balProductIDs[selectedOptions.ballistics.type]);
    }
    if (selectedOptions.spinal.selected) {
        // spinal protector is same as abdominal (including ballistic panel) so referencing same product IDs
        addToItems(selectedOptions.abs.productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.abs.balProductIDs[selectedOptions.ballistics.type]);
    }
    if (selectedOptions.groin.selected) {
        addToItems(selectedOptions.groin.options[selectedOptions.groin.type].productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.groin.options[selectedOptions.groin.type].balProductIDs[selectedOptions.ballistics.type]);
    }

    /* ****************************** 5. PATCHES ****************************** */

    if (selectedOptions.patches.arm.selected) {
        addToItems(selectedOptions.patches.arm.productID)
    } else if (selectedOptions.patches.front.selected || selectedOptions.patches.back.selected) {
        addToItems(selectedOptions.patches.backer.productID)
    }

    /* ****************************** 6. BATTLE BELT ****************************** */

    if (selectedOptions.belt.selected) {
        addToItems(selectedOptions.belt.productIDs[selectedOptions.platform.color]);
        addToItems(selectedOptions.belt.balProductID);
        addToItems(selectedOptions.belt.options[selectedOptions.belt.type].productIDs[selectedOptions.platform.color]);
    }

    // include B1X belt, ballistics, and chosen attachment


    /* ****************************** 7. EXTRA ACCESSORIES ****************************** */

    // if (selectedOptions.extraacc.p7pouchset.selected) {
    //     addToItems(selectedOptions.extraacc.p7pouchset.productID);
    // }
  if (selectedOptions.extraacc.p7pouchset3.selected) {
        addToItems(selectedOptions.extraacc.p7pouchset3.productID);
    }
   if (selectedOptions.extraacc.p7pouchset4.selected) {
         addToItems(selectedOptions.extraacc.p7pouchset4.productID);
     }
   if (selectedOptions.extraacc.p7pouchset5.selected) {
         addToItems(selectedOptions.extraacc.p7pouchset5.productID);
     }

    if (selectedOptions.extraacc.oneps.selected != false) {

        // turn selectedOptions into a string that will match variant title
        var onepsTitle =
            selectedOptions.extraacc.oneps.slingType + ' / ' +
            selectedOptions.extraacc.oneps.attachType;

        // loop through platform variants to get ID and add to formData for submission
        for (let index = 0; index < onepsProductData.variants.length; index++) {
            // const element = array[index];
            if ((onepsProductData.variants[index].title).toLowerCase() == (onepsTitle).toLowerCase()) {
                addToItems(onepsProductData.variants[index].id)
            }
        }
    }

    if (selectedOptions.helmet.selected) {

        var IHSColorFullNames = {
            bb: 'BLACK/BLACK',
            oo: 'OD/OD',
            od: 'OD/BLACK',
            mc: 'Coyote'
        }

        // no MC helmet, if MC is selected, assign black/black.
        var ihsColor = selectedOptions.platform.color;
        // if (ihsColor == 'mc') {
            //     ihsColor = 'bb';
        // }

        var ihsTitle =
            selectedOptions.helmet.cut + ' / ' +
            selectedOptions.helmet.weight + ' / ' +
            IHSColorFullNames[ihsColor];

        // loop through platform variants to get ID and add to formData for submission
        for (let index = 0; index < ihsProductData.variants.length; index++) {
            if ((ihsProductData.variants[index].title).toLowerCase() == ihsTitle.toLowerCase()) {
                addToItems(ihsProductData.variants[index].id)
            }
        }
    }

    /**** Assorted items only on some configurators */
    if (selectedOptions.hasOwnProperty('asr_bag')) {
        if (selectedOptions.asr_bag.selected) {
            addToItems(selectedOptions.asr_bag.productIDs[selectedOptions.platform.color]);
        }
    }
    if (selectedOptions.hasOwnProperty('asr_mag_pouch')) {
        if (selectedOptions.asr_mag_pouch.selected) {
            addToItems(selectedOptions.asr_mag_pouch.productIDs[selectedOptions.platform.color]);
        }
    }

    async function submitToCart() {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        const cartResponse = await response.json();
        return cartResponse;
    }

   submitToCart() 
        .then(cartResponse => {
            console.log(cartResponse);
            if (cartResponse.hasOwnProperty('items')) {
                location.href = "/cart";
            } else {
                alert('Error: Unable to add to cart')
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}